module.exports = __webpack_public_path__ + "img/Counting03-min.7758c401.png";